import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import { Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col } from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

// Moldes de soplado: dan forma a la botella a partir de la preforma.
// En maquinas de un paso van ligados al molde de inyeccion que hace la preforma; en las
// sopladoras de preforma (M8, APF) solo se anota el gramaje de la preforma.
const VACIO = {
  nombre: "",
  clave: "",
  forma: "",
  mililitros: 0,
  cavidades: 1,
  ciclo: 0,
  botellasCiclo: 0,
  rosca: "",
  gramajePreforma: 0,
  moldeInyeccion: "",
  maquinas: [],
  descripcion: "",
};

function ListadoMoldesSoplado() {
  const { user } = useContext(AuthContext);
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_SOPLADO;
  const URL_INYECCION = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [moldes, setMoldes] = useState([]);
  const [inyeccion, setInyeccion] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [buscar, setBuscar] = useState("");
  const [filtroMaquina, setFiltroMaquina] = useState("");
  const [modal, setModal] = useState(false);
  const [idEdit, setIdEdit] = useState(null);
  const [f, setF] = useState(VACIO);

  useEffect(() => {
    getMoldes();
    axios.get(URL_INYECCION, headers).then((r) => setInyeccion(r.data)).catch((e) => console.log(e));
    // Orden natural: M1, M2 ... M19, luego APF, INYECTORA, PF...
    axios
      .get(URL_MAQUINAS, headers)
      .then((r) => setMaquinas(r.data.sort((x, y) => x.nombre.localeCompare(y.nombre, "es", { numeric: true }))))
      .catch((e) => console.log(e));
  }, []);
  function getMoldes() {
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
  }

  const set = (campo, valor) => setF((prev) => ({ ...prev, [campo]: valor }));

  function abreNuevo() {
    setIdEdit(null);
    setF(VACIO);
    setModal(true);
  }
  function abreEdit(a) {
    setIdEdit(a._id);
    setF({
      ...VACIO,
      ...a,
      moldeInyeccion: a.moldeInyeccion ? a.moldeInyeccion._id || a.moldeInyeccion : "",
      maquinas: (a.maquinas || []).map((m) => m._id || m),
    });
    setModal(true);
  }

  // Al elegir el molde de inyeccion se proponen su rosca, gramaje y maquinas.
  function eligeInyeccion(id) {
    const iny = inyeccion.find((x) => x._id === id);
    setF((prev) => ({
      ...prev,
      moldeInyeccion: id,
      ...(iny
        ? {
            rosca: prev.rosca || iny.rosca || "",
            gramajePreforma: iny.gramaje || prev.gramajePreforma,
            maquinas: prev.maquinas.length ? prev.maquinas : (iny.maquinas || []).map((m) => m._id || m),
          }
        : {}),
    }));
  }

  function toggleMaquina(id) {
    setF((prev) => ({
      ...prev,
      maquinas: prev.maquinas.includes(id) ? prev.maquinas.filter((x) => x !== id) : [...prev.maquinas, id],
    }));
  }

  function guardar() {
    if (!f.nombre.trim()) {
      Swal.fire("Atención", "Captura el nombre del molde", "warning");
      return;
    }
    const body = {
      nombre: f.nombre.trim(),
      clave: f.clave || "",
      forma: (f.forma || "").toUpperCase(),
      mililitros: Number(f.mililitros) || 0,
      cavidades: Number(f.cavidades) || 1,
      ciclo: Number(f.ciclo) || 0,
      botellasCiclo: Number(f.botellasCiclo) || 0,
      rosca: String(f.rosca || "").trim().toUpperCase(),
      gramajePreforma: Number(f.gramajePreforma) || 0,
      moldeInyeccion: f.moldeInyeccion || "",
      maquinas: f.maquinas,
      descripcion: f.descripcion || "",
    };
    const req = idEdit ? axios.patch(`${URL_MOLDES}/${idEdit}`, body, headers) : axios.post(URL_MOLDES, body, headers);
    req
      .then(() => {
        setModal(false);
        Swal.fire("Listo", "Molde guardado", "success");
        getMoldes();
      })
      .catch((error) =>
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          footer: `${error.response ? JSON.stringify(error.response.data) : error}`,
        })
      );
  }

  const numMaq = (a) => {
    const n = parseInt(String((a.maquinas || [])[0]?.nombre || "").replace(/\D/g, ""), 10);
    return isNaN(n) ? 999 : n;
  };
  const filtrados = moldes
    .filter((a) => !filtroMaquina || (a.maquinas || []).some((m) => (m._id || m) === filtroMaquina))
    .filter((a) => {
      if (!buscar) return true;
      const t = buscar.toLowerCase();
      return `${a.nombre} ${a.clave} ${a.forma} ${a.rosca} ${a.mililitros}`.toLowerCase().includes(t);
    })
    .sort(
      (a, b) =>
        numMaq(a) - numMaq(b) ||
        String((a.maquinas || [])[0]?.nombre).localeCompare(String((b.maquinas || [])[0]?.nombre)) ||
        b.mililitros - a.mililitros
    );

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "catalogos.moldesSoplado.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-wine-bottle" style={{ marginRight: 8, color: "#0ea5e9" }} />
                  Moldes de Soplado
                </h3>
                <p className="page-subtitle">Botellas — mililitros, cavidades, ciclo y preforma que usan</p>
              </div>
              <div className="page-actions">
                {puede(user, "catalogos.moldesSoplado.crear") && (
                  <Button size="sm" color="success" onClick={abreNuevo}>
                    <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Molde
                  </Button>
                )}
              </div>
            </div>
            <Row style={{ marginBottom: 10 }}>
              <Col md={4}>
                <Input bsSize="sm" placeholder="Buscar (forma, ml, clave, rosca)..." value={buscar} onChange={(e) => setBuscar(e.target.value)} />
              </Col>
              <Col md={3}>
                <Input bsSize="sm" type="select" value={filtroMaquina} onChange={(e) => setFiltroMaquina(e.target.value)}>
                  <option value="">Todas las máquinas</option>
                  {maquinas.map((m) => (
                    <option key={m._id} value={m._id}>
                      {m.nombre}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={5} style={{ textAlign: "right" }}>
                <small className="text-muted">{filtrados.length} moldes</small>
              </Col>
            </Row>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Máquinas</th>
                  <th className="tituloTabla">Nombre</th>
                  <th className="tituloTabla">ml</th>
                  <th className="tituloTabla">Cavidades</th>
                  <th className="tituloTabla">Ciclo (s)</th>
                  <th className="tituloTabla">Botellas/ciclo</th>
                  <th className="tituloTabla">Rosca</th>
                  <th className="tituloTabla">Preforma (g)</th>
                  <th className="tituloTabla">Molde inyección</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {filtrados.map((a) => (
                  <tr key={a._id}>
                    <td>{(a.maquinas || []).map((m) => m.nombre).join(", ")}</td>
                    <td>
                      {a.nombre}
                      {a.descripcion ? (
                        <i className="fas fa-info-circle" title={a.descripcion} style={{ marginLeft: 6, color: "#0ea5e9", cursor: "help" }} />
                      ) : null}
                    </td>
                    <td align="right">{Number(a.mililitros || 0).toLocaleString("es-MX")}</td>
                    <td align="center">{a.cavidades}</td>
                    <td align="center">{a.ciclo || "-"}</td>
                    <td align="center">{a.botellasCiclo || "-"}</td>
                    <td>{a.rosca || "-"}</td>
                    <td align="center">{a.gramajePreforma || "-"}</td>
                    <td>{a.moldeInyeccion ? a.moldeInyeccion.nombre : <span className="text-muted">Sopladora</span>}</td>
                    <td>
                      {puede(user, "catalogos.moldesSoplado.editar") && (
                        <Button color="info" size="sm" onClick={() => abreEdit(a)}>
                          <i className="far fa-edit"></i>
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="lg" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalHeader toggle={() => setModal(!modal)}>
          <i className="fas fa-wine-bottle" style={{ marginRight: 8, color: "#0ea5e9" }} />
          {idEdit ? "Editar" : "Nuevo"} Molde de Soplado
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={5}>
              <Label>Nombre *</Label>
              <Input type="text" placeholder="Ej. SIN FIN 1500 ml" value={f.nombre} onChange={(e) => set("nombre", e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Forma</Label>
              <Input type="text" placeholder="SIN FIN, BOSTON..." value={f.forma} onChange={(e) => set("forma", e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Clave</Label>
              <Input type="text" value={f.clave} onChange={(e) => set("clave", e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>Mililitros</Label>
              <Input type="number" value={f.mililitros} onChange={(e) => set("mililitros", e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Cavidades</Label>
              <Input type="number" value={f.cavidades} onChange={(e) => set("cavidades", e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Ciclo (seg)</Label>
              <Input type="number" value={f.ciclo} onChange={(e) => set("ciclo", e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Botellas por ciclo</Label>
              <Input type="number" value={f.botellasCiclo} onChange={(e) => set("botellasCiclo", e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Molde de inyección (preforma)</Label>
              <Input type="select" value={f.moldeInyeccion} onChange={(e) => eligeInyeccion(e.target.value)}>
                <option value="">Ninguno (sopladora de preforma)</option>
                {inyeccion.map((m) => (
                  <option key={m._id} value={m._id}>
                    {m.nombre}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Rosca</Label>
              <Input type="text" placeholder="R28, R24-410..." value={f.rosca} onChange={(e) => set("rosca", e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Preforma (g)</Label>
              <Input type="number" value={f.gramajePreforma} onChange={(e) => set("gramajePreforma", e.target.value)} />
            </Col>
          </Row>
          <br />
          <Label>Notas</Label>
          <Input type="text" value={f.descripcion} onChange={(e) => set("descripcion", e.target.value)} />
          <br />
          <Label>Máquinas donde se monta</Label>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
              gap: "2px 12px",
              border: "1px solid #e2e8f0",
              borderRadius: 6,
              padding: 8,
            }}
          >
            {maquinas.map((m) => (
              <label key={m._id} style={{ display: "flex", alignItems: "center", gap: 8, margin: 0, cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={f.maquinas.includes(m._id)}
                  onChange={() => toggleMaquina(m._id)}
                  style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                />
                <span>{m.nombre}</span>
              </label>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModal(false)}>
            Cancelar
          </Button>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoMoldesSoplado;
